<template>
  <div>
    <div class="header pb-8 pt-5 pt-lg-6 d-flex align-items-center profile-header">
      <b-container fluid>
        <!-- Mask -->
        <span class="mask"></span>
        <!-- Header container -->
        <h1 class="text-center">Panel de Configuración</h1>
        <b-container fluid class="d-flex align-items-center">
          <b-row >
            <b-col lg="7" md="10">
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </div>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="12" class="order-xl-1">
          <card>
            <b-row align-v="center" slot="header" >
              <b-col cols="8">
                <h3 class="mb-0">Crear colaborador</h3>
              </b-col>
            </b-row>

            <b-form @submit.prevent="updateProfile">
              <base-alert v-if="success === true" type="success" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Bien hecho!</strong> El colaborador se creo existosamente.
              </base-alert>
              <base-alert v-if="success === false" type="danger" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Error!</strong> {{error}}
              </base-alert>
              <h6 class="heading-small text-muted mb-4">Información del colaborador</h6>

              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Número de colaborador"
                      placeholder=""
                      v-model="number"
                      name="number"
                      required
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="Nombre"
                      label="Nombre"
                      placeholder=""
                      v-model="name"
                      name="nombre"
                      required
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <b-row >
                  <b-col lg="6">
                    <base-input
                      label="Apellido Paterno"
                      placeholder=""
                      v-model="firstLastname"
                      name="firstLastname"
                      required
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      label="Apellido Materno"
                      placeholder=""
                      v-model="secondLastname"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      label="Correo electrónico"
                      placeholder=""
                      v-model="email"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      label="Teléfono"
                      placeholder=""
                      v-model="phone"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Género</label>
                    <multiselect
                      :show-labels="false"
                      v-model="gender"
                      :options="['Mujer','Hombre']"
                      placeholder='Selecciona el género de usuario'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      label="Hospital al que pertenece"
                      placeholder=""
                      disabled
                      v-model="this.$route.params.nameHospital"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Area</label>
                    <multiselect
                      :show-labels="false"
                      v-model="area"
                      :options="areas"
                      placeholder='Selecciona el area del colaborador'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      label="Especialidad"
                      placeholder=""
                      v-model="specialty"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      label="Especialidad 2"
                      placeholder=""
                      v-model="specialty2"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      label="Campus"
                      placeholder=""
                      v-model="campus"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      label="Máximo de caracteres"
                      placeholder=""
                      v-model="maxChars"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      label="Mínimo de caracteres"
                      placeholder=""
                      v-model="minChars"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Máximo de ordenes"
                      placeholder=""
                      v-model="maxOrders"
                      name="maxOrders"
                      required
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>


              <hr class="my-4">
              <b-button type="submit" variant="primary" class="mt-4">Crear colaborador</b-button>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import qs from 'qs'

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      name: '',
      number: '',
      gender: '',
      firstLastname: '',
      secondLastname: '',
      email: '',
      campus: '',
      phone: '',
      area: '',
      specialty: '',
      specialty2: '',
      maxChars: 0,
      minChars: 0,
      maxOrders: '',
      token: '',
      user: '',
      success: '',
      error: '',
      models: [],
      areas: []
    };
  },
  computed: {
    hasClothesType: function(){
        if (this.gender) {
            let elements = {
                scrub: [],
                pants: [],
                coat: [],
                jacket: []
            }

            if (this.gender == 'Hombre') {
                elements.scrub =  this.models.filter((x) => x.type_id == '2' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
                elements.pants = this.models.filter((x) => x.type_id == '3' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
                elements.coat = this.models.filter((x) => x.type_id == '5' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
                elements.jacket  = this.models.filter((x) => x.type_id == '4' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
            } else {
                elements.scrub =  this.models.filter((x) => x.type_id == '2' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
                elements.pants = this.models.filter((x) => x.type_id == '3' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
                elements.coat = this.models.filter((x) => x.type_id == '5' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
                elements.jacket  = this.models.filter((x) => x.type_id == '4' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
            }
            return elements
        } else {
            return {
                scrub: [],
                pants: [],
                coat: [],
                jacket: []
            }
        }
    }
},
  created() {
    this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_catalogs'}),
      )
      .then((response) => {
        if (!response.data.error.code && response.data.areas) {
          let temp = [], hId
          hId = this.$route.params.hospitalId

          Object.keys(response.data.areas).map((key) => [response.data.areas[key]]).map(function(value) {
              if(value[0].hospital_id == hId)
                temp.push(value[0].name)
          })
          this.areas = temp
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    updateProfile() {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        qs.stringify({
          api_token: this.token,
          user_id: this.user,
          option: 'create_collaborator',
          h_id: this.$route.params.hospitalId,
          c_name: this.name,
          c_number: this.number,
          c_gender: this.gender,
          c_firstLastname: this.firstLastname,
          c_secondLastname: this.secondLastname,
          c_area: this.area,
          c_specialty: this.specialty,
          c_specialty2: this.specialty2,
          c_maxChars: this.maxChars,
          c_minChars: this.minChars,
          c_mail: this.email,
          c_phone: this.phone,
          c_campus: this.campus
        }),
      )
      .then((response) => {
        if (!response.data.error.code) {
          this.success = true
        } else {
          this.success = false
          this.error = response.data.error.description
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    getColors(index){
        if (index) {
            return this.models.filter((x) => x.name == index).map(y => y.sharedColor)[0].map(z => z.name)
        } else {
            return ''
        }
    },
  }
};
</script>
<style></style>
